import { useParams } from "@tanstack/react-router"
import { getTenantSlug } from "./slice"
import { useSelector } from "@/base/store"

export default function useMaybeTenant(): string | undefined {
  const { tenantSlug } = useParams({ strict: false })
  const storedSlug = useSelector(getTenantSlug)

  return tenantSlug && storedSlug === tenantSlug ? tenantSlug : undefined
}
